import { HTTP_INTERCEPTORS } from '@angular/common/http'
import {
  type ModuleWithProviders,
  NgModule,
  Optional
} from '@angular/core'
import {
  HubConfigurationModule,
  HubConfigurationService
} from '@inside-hub-app/hub-configuration'
import { HubStorageModule } from '@inside-hub-app/hub-storage'
import { NGXLogger } from 'ngx-logger'
import { PpTranslateDirective } from './directives/pp-translate.directive'
import { type Environment } from './environments'
import {
  ENVIRONMENT,
  STORAGE_PREFIX,
  TRANSLATION_PREFIX
} from './injection-tokens'
import { PpTranslatePipe } from './pipes/pp-translate.pipe'
import { PpDealerIdInterceptor } from './interceptors/pp-dealer-id.interceptor'
import { AUTH_EXCLUDED_URLS_TOKEN, XAuthTokenInterceptor } from '@inside-hub-app/hub-authentication'

export class PpModuleConfig {
  constructor (
    public storagePrefix: string,
    public translationPrefix: string,
    public environment: Environment
  ) {}
}

export class PpModuleChildConfig {
  constructor (public translationPrefix?: string) {}
}

@NgModule({
  declarations: [PpTranslatePipe, PpTranslateDirective],
  imports: [HubStorageModule, HubConfigurationModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XAuthTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PpDealerIdInterceptor,
      multi: true
    },
    PpTranslatePipe
  ],
  exports: [PpTranslatePipe, PpTranslateDirective]
})
export class PpModule {
  constructor (
    @Optional() private readonly logger?: NGXLogger,
    @Optional() private readonly hubConfigurationService?: HubConfigurationService
  ) {
    if (this.logger && this.hubConfigurationService) {
      this.hubConfigurationService.setLoggerLevel(this.logger)
    }
  }

  static forRoot (config: PpModuleConfig): ModuleWithProviders<PpModule> {
    return {
      ngModule: PpModule,
      providers: [
        { provide: AUTH_EXCLUDED_URLS_TOKEN, useValue: config.environment.authorizationExcludedUrls },
        { provide: ENVIRONMENT, useValue: config.environment },
        { provide: STORAGE_PREFIX, useValue: config.storagePrefix || '' },
        { provide: TRANSLATION_PREFIX, useValue: config.translationPrefix || '' }
      ]
    }
  }

  static forChild (config?: PpModuleChildConfig): ModuleWithProviders<PpModule> {
    return {
      ngModule: PpModule,
      providers: [
        ...(config.translationPrefix
          ? [
              {
                provide: TRANSLATION_PREFIX,
                useValue: config.translationPrefix
              }
            ]
          : [])
      ]
    }
  }
}
